﻿import './sections.css'

function ShieldCheckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2 5 5v6.2c0 4.5 2.7 8.7 7 10.8 4.3-2.1 7-6.3 7-10.8V5L12 2Z"
        fill="#c9a84c"
        stroke="#7a5c1e"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="m8.5 12 2.3 2.3 4.7-4.8"
        stroke="#0e1820"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function TrustSection() {
  const items = [
    { icon: '🏢', label: 'Big 4 Integration', sub: 'Powering CRM for 15,000+ clients' },
    { icon: <ShieldCheckIcon />, label: 'Patented Integrity Detection', sub: 'AI-powered fraud detection on every interview' },
    { icon: '🌍', label: 'Global Scale', sub: 'Enterprise-grade infrastructure' },
    { icon: '🔒', label: 'Enterprise Security', sub: 'Meets Big 4 & Fortune 100 standards' },
  ]
  return (
    <section className="trust-section section">
      <div className="container">
        <h3 className="trust-title">Enterprise-Proven at Global Scale</h3>
        <div className="trust-grid">
          {items.map(i => (
            <div key={i.label} className="trust-card">
              <div className="trust-icon">{i.icon}</div>
              <div className="trust-text">
                <strong>{i.label}</strong>
                <span>{i.sub}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

